import { i18n } from '@/plugins/vue-i18n';
import store from '@state/store';

export const getErrorMessageKey = error => {
  logError(error);
  if (error && error.data) {
    const { code, message } = error.data;
    if (i18n.te(`errorcodes.${message}`)) {
      return `errorcodes.${message}`;
    } else if (i18n.te(`errorcodes.${code}`)) {
      return `errorcodes.${code}`;
    }
  } else if (isJavaScriptError(error)) {
    return 'errorcodes.FRONTEND_ERROR';
  }

  return 'errorcodes.UNKNOWN_ERROR';
};

// can parse old substore errors
export const getLegacyErrorMessage = error => {
  const substoreError = getSubstoreError(error);
  if (substoreError != null) {
    logError(error);
    return substoreError.message;
  }
  return i18n.t(getErrorMessageKey(error));
};

export const mapContractState = status => {
  // don't fill state if there is no contract data
  if (!status || !i18n.te(`common.contractStatus_${status}`)) {
    return i18n.t('common.unknown');
  }

  return i18n.t(`common.contractStatus_${status}`);
};

export const addOptionalSuffix = (prefix, s) => {
  const suffix = ['_' + s, ''].find(suffix => i18n.te(`${prefix}${suffix}`));
  if (suffix === undefined) return null;
  return `${prefix}${suffix}`;
};

export default {
  getErrorMessageKey,
  getLegacyErrorMessage,
  mapContractState,
  addOptionalSuffix,
};

const getSubstoreError = error => {
  if (['SUBSTORE_ERROR', 'SUBSTORE_ERROR_FATAL'].includes(error?.data?.code)) return error.data.errorDetails?.head?.fault;
  return null;
};

const isJavaScriptError = error => {
  return error && error.message && error.fileName && error.lineNumber && error.stack;
};

const logError = error => {
  if (store?.getters?.['system/isProduction']) return;
  // eslint-disable-next-line no-console
  console.error('parseError:', error);
};
